import $ from 'jquery';
import abgrcs_config from './abgrcs_config.js';
import ReactDOM from 'react-dom/client';

function Home() {
  return (
    <div>
      	<div class="row">
            <div class="col-md-2">
				<img width="150px" src="img/img.jpeg" />
            </div>
            <div class="col-md-10">
                <h1 class="page-header" style={{"text-align":"center"}}>
					مرحبا بكم في منصة<br />
					Green recruitments<br />
                </h1>
				<p style={{"text-align":"center", "font-size":"18px"}}>
					هي منصة حساب رصيد النقاط لملف الترشح في التوظيف /أو مسابقة على أساس الشهادات للالتحاق برتبة أستاذ مساعد صنف ب
				</p>
            </div>
        </div>
        
        <div class="row size1">
            <div class="col-md-12">
                <form class="form" onsubmit="search(); return false;">
					<div class="row">
            			<div class="col-sm-12">
							<table width="100%">
								<tr>
									<td style={{"text-align" : "left", "background-color" : "#76D7C4"}}>
										<p style={{"text-align":"right", "font-size":"16px"}}>
											<b>أدخل بيانات ملف ترشحك : </b>
										</p>
									</td>
									<td style={{"text-align" : "left", "background-color" : "#76D7C4"}}>
										<b>الحساب الفرعي : </b>
									</td>
								</tr>
								<tr>
									<td>
										<div class="form-group">
											<p style={{"color" : "green"}}><b>1. ملائمة شعبة وتخصص شهادة المترشح : </b></p>
											<select type="text" class="form-control" onChange={(e) => { Calculate(e); }} id="ab_01" style={{"width" : ""}}>
												<option value="2">الشعبة الاولى / التخصص الأول</option>
												<option value="1.75">الشعبة الأولى / التخصص الثاني</option>
												<option value="1.5	">الشعبة الأولى / التخصص الثالث</option>
												<option value="1.25">الشعبة الأولى / التخصص الرابع</option>
												<option value="1.5">الشعبة الثانية / التخصص الأول</option>
												<option value="1.25">الشعبة الثانية / التخصص الثاني</option>
												<option value="1">الشعبة الثانية / التخصص الثالث</option>
											</select>
										</div>
									</td>
									<td style={{"text-align" : "center", "font-size" : "20px"}}>
										<span id="sub_total_01">2</span>
									</td>
								</tr>
								<tr>
									<td>
										<p style={{"color" : "green"}}><b>2. تقدير الشهادة : </b></p>
										<select type="text" class="form-control" onChange={(e) => { Calculate(e); }} id="ab_02" style={{"width" : ""}}>
											<option value="1">تقدير حسن جدا   أو   مشرف جدا </option>
											<option value="0.5">تقدير حسن أو  مشرف  أو عدم تحديد تقدير الشهادة</option>
										</select>
									</td>
									<td style={{"text-align" : "center", "font-size" : "20px"}}>
										<span id="sub_total_02">1</span>
									</td>
								</tr>
								<tr>
									<td> 
										<p style={{"color" : "green"}}><b>3. تاريخ الحصول على الدكتوراه بالنظر إلى تاريخ فتح المسابقة : </b></p>
										<div class="row">
											<div class="col-md-6">
												<label><b>تاريخ الحصول على الدكتوراه : </b></label>
												<div class="form-group">
													<input id="ab_03" type="date" class="form-control" onChange={(e) => { Calculate(e); }} placeholder="" style={{"width" : ""}} />
												</div>
											</div>
											<div class="col-md-6">
												<label>تاريخ فتح المسابقة : </label>
												<div class="form-group">
													<input id="ab_04" type="date" class="form-control" onChange={(e) => { Calculate(e); }} placeholder="" style={{"width" : ""}} />
												</div>
											</div>
										</div>
									</td>
									<td style={{"text-align" : "center", "font-size" : "20px"}}>
										<span id="sub_total_03">0</span>
									</td>
								</tr>
								<tr>
									<td>
										<p style={{"color" : "green"}}><b>4. الأعمال العلمية المنجزة من طرف المترشح في شعبته وتخصصه قبل وبعد حصوله على الشهادة : </b></p>
										<p style={{"color" : "green"}}><b>1.4 المنشورات العلمية : </b></p>
										<p style={{"text-align":"center"}}><b>أدرج أفضل مقالين (من حيث ترتيب المؤلف) في كل صنف</b></p>
										<div id="abgrcs_articles">
											<div class="row">
												<div class="col-sm-12">
													<p><b>مقال علمي في مجلة علمية مصنفة A+</b></p>
													<label> المقال الأول : </label>
													<select id="ab_06_a_01" name="ab_06_a_01" class="form-control" onChange={(e) => { Calculate(e); }} style={{"width" : ""}}>
														<option value="0">لايوجد</option>
														<option value="5">أول مؤلف 100٪</option>
														<option value="2.5">ثاني مؤلف 50٪</option>
														<option value="1.25">ثالث مؤلف فأكثر 25٪</option>
													</select>
												</div>
												<div class="col-sm-12">
													<label> المقال الثاني : </label>
													<select id="ab_06_a_02" name="ab_06_a_02" class="form-control" onChange={(e) => { Calculate(e); }} style={{"width" : ""}}>
														<option value="0">لايوجد</option>
														<option value="5">أول مؤلف 100٪</option>
														<option value="2.5">ثاني مؤلف 50٪</option>
														<option value="1.25">ثالث مؤلف فأكثر 25٪</option>
													</select>
												</div>
											</div>
											<div class="row">
												<div class="col-sm-12">
													<p><b>مقال علمي في مجلة علمية مصنفة A، أو براءة اختراع PCT OMPI</b></p>
													<label> المقال الأول : </label>
													<select id="ab_06_b_01" name="ab_06_b_01" class="form-control" onChange={(e) => { Calculate(e); }} style={{"width" : ""}}>
														<option value="0">لايوجد</option>
														<option value="4">أول مؤلف 100٪</option>
														<option value="2">ثاني مؤلف 50٪</option>
														<option value="1">ثالث مؤلف فأكثر 25٪</option>
													</select>
												</div>
												<div class="col-sm-12">
													<label> المقال الثاني : </label>
													<select id="ab_06_b_02" name="ab_06_b_02" class="form-control" onChange={(e) => { Calculate(e); }} style={{"width" : ""}}>
														<option value="0">لايوجد</option>
														<option value="4">أول مؤلف 100٪</option>
														<option value="2">ثاني مؤلف 50٪</option>
														<option value="1">ثالث مؤلف فأكثر 25٪</option>
													</select>
												</div>
											</div>
											<div class="row">
												<div class="col-sm-12">
													<p><b>مقال علمي في مجلة علمية مصنفة B ، أو براءة اختراع INAPI</b></p>
													<label> المقال الأول : </label>
													<select id="ab_06_c_01" name="ab_06_c_01" class="form-control" onChange={(e) => { Calculate(e); }} style={{"width" : ""}}>
														<option value="0">لايوجد</option>
														<option value="3">أول مؤلف 100٪</option>
														<option value="1.5">ثاني مؤلف 50٪</option>
														<option value="0.75">ثالث مؤلف فأكثر 25٪</option>
													</select>
												</div>
												<div class="col-sm-12">
													<label> المقال الثاني : </label>
													<select id="ab_06_c_02" name="ab_06_c_02" class="form-control" onChange={(e) => { Calculate(e); }} style={{"width" : ""}}>
														<option value="0">لايوجد</option>
														<option value="3">أول مؤلف 100٪</option>
														<option value="1.5">ثاني مؤلف 50٪</option>
														<option value="0.75">ثالث مؤلف فأكثر 25٪</option>
													</select>
												</div>
											</div>
											<div class="row">
												<div class="col-sm-12">
													<p><b>مقال علمي في مجلة علمية مصنفة C</b></p>
													<label> المقال الأول : </label>
													<select id="ab_06_d_01" name="ab_06_d_01" class="form-control" onChange={(e) => { Calculate(e); }} style={{"width" : ""}}>
														<option value="0">لايوجد</option>
														<option value="1.5">أول مؤلف 100٪</option>
														<option value="0.75">ثاني مؤلف 50٪</option>
														<option value="0.375">ثالث مؤلف فأكثر 25٪</option>
													</select>
												</div>
												<div class="col-sm-12">
													<label> المقال الثاني : </label>
													<select id="ab_06_d_02" name="ab_06_d_02" class="form-control" onChange={(e) => { Calculate(e); }} style={{"width" : ""}}>
														<option value="0">لايوجد</option>
														<option value="1.5">أول مؤلف 100٪</option>
														<option value="0.75">ثاني مؤلف 50٪</option>
														<option value="0.375">ثالث مؤلف فأكثر 25٪</option>
													</select>
												</div>
											</div>
										</div>
									</td>
									<td rowSpan="4" style={{"text-align" : "center", "font-size" : "20px"}}>
										<span id="sub_total_04">0</span>
									</td>
								</tr>
								<tr>
									<td>
										<label>كتاب علمي في تخصصه يحمل الرقم الدولي المعياري ردمك (عدد الكتب)</label>
										<input id="ab_07" type="number" class="form-control" onChange={(e) => { Calculate(e); }} placeholder="" style={{"width" : ""}} />
									</td>
								</tr>
								<tr>
									<td>
										<p style={{"color" : "green"}}><b>2.4 المداخلات العلمية : </b></p>
										<label>مداخلة دولية (عدد المداخلات)</label>
										<input id="ab_10" type="number" class="form-control" onChange={(e) => { Calculate(e); }} placeholder="" style={{"width" : ""}} />
									</td>
								</tr>
								<tr>
									<td>
										<label>مداخلة محلية (عدد المداخلات)</label>
										<input id="ab_11" type="number" class="form-control" onChange={(e) => { Calculate(e); }} placeholder="" style={{"width" : ""}} />
									</td>
								</tr>
								<tr>
									<td>
										<p style={{"color" : "green"}}><b>5. الخبرة المهنية المكتسبة من طرف المترشح : </b></p>
										<p style={{"color" : "green"}}><b>1.5 التدريس بمؤسسات التعليم العالي : </b></p>
										<label> دروس  (عدد السداسيات)</label>
										<input id="ab_12" type="number" class="form-control" onChange={(e) => { Calculate(e); }} placeholder="" style={{"width" : ""}} />
									</td>
									<td rowSpan="5" style={{"text-align" : "center", "font-size" : "20px"}}>
										<span id="sub_total_05">0</span>
									</td>
								</tr>
								<tr>
									<td>
										<label> أعمال موجهة (عدد السداسيات)</label>
										<input id="ab_13" type="number" class="form-control" onChange={(e) => { Calculate(e); }} placeholder="" style={{"width" : ""}} />
									</td>
								</tr>
								<tr>
									<td>
										<label> أعمال تطبيقية (عدد السنوات)</label>
										<input id="ab_14" type="number" class="form-control" onChange={(e) => { Calculate(e); }} placeholder="" style={{"width" : ""}} />
									</td>
								</tr>
								<tr>
									<td>
										<p style={{"color" : "green"}}><b>2.5 الخبرة المهنية المكتسبة من طرف المترشح في مجال التدريس بالمؤسسات التابعة لقطاعات النشاطات الأخرى بعد الحصول على الشهادة المطلوبة (عدد السنوات) : </b></p>
										<input id="ab_15" type="number" class="form-control" onChange={(e) => { Calculate(e); }} placeholder="" style={{"width" : ""}} />
									</td>
								</tr>
								<tr>
									<td>
										<p style={{"color" : "green"}}><b>3.5 الخبرة المهنية المكتسبة من طرف المترشح بعد الحصول على الشهادة المطلوبة، بعنوان شغل مناصب التأطير على مستوى المؤسسات والإدارات العمومية و/أو المؤسسات والهيئات العمومية والخاصة (عدد السنوات) : </b></p>
										<input id="ab_16" type="number" class="form-control" onChange={(e) => { Calculate(e); }} placeholder="" style={{"width" : ""}} />
									</td>
								</tr>
								<tr>
									<td>
										<p style={{"color" : "green"}}><b>6. المقابلة مع لجنة الانتقاء : </b></p>
										<ul>
											<li>القدرة على التحليل والتلخيص</li>
											<li>وضوح وسلاسة الخطاب </li>
											<li>القدرة على التواصل </li>
											<li>المهارات العلمية الخاصة</li>
										</ul>
										<input id="ab_17" type="number" class="form-control" onChange={(e) => { Calculate(e); }} placeholder="" style={{"width" : ""}} />
									</td>
									<td style={{"text-align" : "center", "font-size" : "20px"}}>
										<span id="sub_total_06">0</span>
									</td>
								</tr>
								<tr>
									<td colSpan={2} style={{"text-align" : "left", "background-color" : "#76D7C4", "font-size" : "18px"}}>
										<div style={{}}>
											<b style={{"color" : "black"}}>النتيجة العامة : </b>
											<span id="result_to_show" style={{"color" : "green"}}>
												<span style={{"text-align" : "right"}}><b>3 نقطة</b></span>
											</span>
										</div>
									</td>
								</tr>
							</table>
						</div>
					</div>
					<div class="row">
						<div class="col-lg-12" style={{"text-align" : "right", "font-size" : "16px"}}>
							<br />
							<p><b>ملاحظة هامة حول التوظيف : </b></p>
							<ol>
								<li>يقصى من المسابقة المترشح الذي تغيب عن المقابلة</li>
								<li>
									يتم الفصل بين المترشحين عند تساوي النقاط حسب الاولويات التالية : 
									<ul>
										<li>العلامة المتحصل عليها من طرف المترشح بعنوان معيار المنشورات العلمية؛</li>
										<li>العلامة المتحصل عليها من طرف المترشح بعنوان معيار المقابلة مع لجنة الانتقاء؛</li>
										<li>العلامة المتحصل عليها من طرف المترشح بعنوان معيار الخبرة المهنية المكتسبة في مجال التدريس بمؤسسات التعليم العالي؛</li>
										<li>العلامة المتحصل عليها من طرف المترشح بعنوان معيار تاريخ الحصول على الشهادة.</li>
									</ul>
								</li>
								<li>
									في حالة ما إذا تعذر الفصل بين المترشحين المتساوين في النقاط رغم تطبيق المقاييس المذكورة أعلاه، فإنه يتم حسب الأولوية، تطبيق المقاييس الثانوية الآتية : 
									<ul>
										<li>أصنـاف (الأشخـــاص ذوي الاحــتيــاجــات الخاصة الــذيــن لـــديهم القدرة على أداء المهام المرتبطة بالرتبة المراد الالتحاق بها؛</li>
										<li>سن المترشح (الأولوية للأكبر سّنًا)؛</li>
										<li>لوضعية العائلية للمترشح (متزوج له أولاد، متزوج بدون أولاد، متكفل بعائلة، أعزب).</li>
									</ul>
								</li>
							</ol>
							<p><a target="_blank" href="https://drive.google.com/drive/folders/1by_pniUuGafBQtd9Rr5l5-m6BGCPPPKE">المرجع القانوني</a></p>
						</div>
					</div>
				</form>
            </div>
        </div>

        <hr />
        
        <footer>
            <div class="row">
                <div class="col-lg-3">
					<div style={{"float" : "left", "padding-right" : "10px"}}>
                        <img src="img/img.png" class="img-thumbnail img-circle elevation-2" style={{"width" : "120px", "height" : "120px"}} />
                    </div>
					<div style={{"float" : "left", "text-align" : "left"}}>
						<p>Copyright &copy; <br /> 2020 - 2024</p>
					</div>
                </div>
                <div class="col-lg-4">
                    <div style={{"float" : "left", "padding-right" : "10px"}}>
                        <img src="uploads/img01.jpg" class="img-thumbnail img-circle elevation-2" style={{"width" : "120px", "height" : "120px"}} />
                    </div>
					<div style={{"float" : "left", "text-align" : "left"}}>
                        Prof. ADALA Laadjal <br /> Founder and Director of <br /> the Green journals Platform
                    </div>
                </div>
                <div class="col-lg-4">
					<div style={{"float" : "left", "padding-right" : "10px"}}>
						<a target="_blank" href="https://www.facebook.com/abgrcs/">
                            <img src="uploads/img02.jpg" class="img-thumbnail img-circle elevation-2" style={{"width" : "120px", "height" : "120px"}} />
                        </a>
					</div>
					<div style={{"float" : "left", "text-align" : "left"}}>
						<a target="_blank" href="https://www.facebook.com/abgrcs/">GHRICI Abdellah</a>
						<p>Technical Supervisor</p>
					</div>
                </div>
            </div>
        </footer>
    </div>
  );
}

function get_zero(id)
{
	var re = parseFloat($("#" + id + "").val());

	if(isNaN(re))
		re = 0;

	return re;
}

function diff_years(date1, date2) 
{
	const diffInMilliseconds = Math.abs(date2 - date1);
    const millisecondsPerYear = 1000 * 60 * 60 * 24 * 365.25; // Average milliseconds per year
    return Math.floor(diffInMilliseconds / millisecondsPerYear);
}

function add_new_line()
{
	const abgrcs_content = ReactDOM.createRoot(document.getElementById('abgrcs_articles'));

	abgrcs_content.render(
		<>
			<div class="row">
				<div class="col-md-2" style={{"display":"none"}}>
					<a href="#" onClick={(e) => { e.preventDefault(); add_new_line(); }}>+</a>
				</div>
				<div class="col-md-5">
					<select id="ab_06" name="ab_06" class="form-control" onChange={(e) => { Calculate(e); }} style={{"width" : ""}}>
						<option value="priority_00">لايوجد</option>
						<option value="priority_01">أول مؤلف 100٪</option>
						<option value="priority_02">ثاني مؤلف 50٪</option>
						<option value="priority_03">ثالث مؤلف فأكثر 25٪</option>
					</select>
				</div>
				<div class="col-md-5">
					<select id="ab_05" name="ab_05" class="form-control" onChange={(e) => { Calculate(e); }} style={{"width" : ""}}>
						<option value="article_01">مقال علمي في مجلة علمية مصنفة أ+ </option>
						<option value="article_02">مقال علمي في مجلة علمية مصنفة ب ، أو براءة اختراع INAPI</option>
						<option value="article_03">مقال علمي في مجلة علمية مصنفة ج (03 نقاط على الأكثر)</option>
						<option value="article_04">مقال علمي في مجلة علمية مصنفة ب ، أو براءة اختراع INAPI</option>
					</select>
				</div>
			</div>
		</>
	);
}

function get_index(val1)
{
	if (val1 == 1) {
		return 1;
	} else if (val1 == 2) {
		return 0.5;
	} else if (val1 == 3) {
		return 0.25;
	}

	return 0;
}

function get_max(val1, val2)
{
	var a1 = ($(val1).val() === undefined) ? 0 : parseFloat($(val1).val());
	var a2 = ($(val2).val() === undefined) ? 0 : parseFloat($(val2).val());
	
	if(a1 == 0 && a2 == 0)
		return 0;
	else if(a1 != 0 && a2 == 0)
		return a1;
	else if(a1 == 0 && a2 != 0)
		return a2;
	else
	{
		var temp = 0;

		if (a1 > a2) {
			temp = a1;
			
			temp += get_index($(val2 + " option:selected").index());
		} else {
			temp = a2;
			
			temp += get_index($(val1 + " option:selected").index());
		}

		return temp;
	}
}

function Update_Sub_Total(sub_total_01, sub_total_02, sub_total_03, sub_total_04, sub_total_05, sub_total_06)
{
	$("#sub_total_01").html(sub_total_01);
	$("#sub_total_02").html(sub_total_02);
	$("#sub_total_03").html(sub_total_03);
	$("#sub_total_04").html(sub_total_04);
	$("#sub_total_05").html(sub_total_05);
	$("#sub_total_06").html(sub_total_06);
}

function Calculate(obj)
{
	var result_to_show = 0;
	
	if (new Date($("#ab_03").val()) > new Date($("#ab_04").val())) {
		// alert("يرجى التحقق من المعلومات المدخلة");
	}

	// ملائمة شعبة وتخصص شهادة المترشح (من 0 الى 2 نقاط) : 
	var menu_1 = parseFloat($("#ab_01").val());
	result_to_show += menu_1;

	//  تقدير الشهادة (من 0,5 الى 1 نقطة) : 
	var menu_2 = parseFloat($("#ab_02").val());
	result_to_show += menu_2;
	
	if ($("#ab_03").val() != "" && $("#ab_04").val() != "") {
		// تاريخ الحصول على الشهادة : 
		var date_01 = new Date($("#ab_03").val());

		// تاريخ فتح المسابقة : 
		var date_02 = new Date($("#ab_04").val());
		
		var date_03 = parseInt(diff_years(date_01, date_02)) * 0.25;
		
		var menu_3 = (date_03 <= 2) ? date_03: 2;
		result_to_show += menu_3;
	}
	
	// 
	var ab_06_a_01 = get_max("#ab_06_a_01", "#ab_06_a_02");
	var ab_06_a_02 = 0;
	var ab_06_a_all = parseFloat(ab_06_a_01) + parseFloat(ab_06_a_02);

	var ab_06_b_01 = get_max("#ab_06_b_01", "#ab_06_b_02");
	var ab_06_b_02 = 0;
	var ab_06_b_all = parseFloat(ab_06_b_01) + parseFloat(ab_06_b_02);
	
	var ab_06_c_01 = get_max("#ab_06_c_01", "#ab_06_c_02");
	var ab_06_c_02 = 0;
	var ab_06_c_all = parseFloat(ab_06_c_01) + parseFloat(ab_06_c_02);

	var ab_06_d_01 = parseFloat($("#ab_06_d_01").val());
	var ab_06_d_02 = parseFloat($("#ab_06_d_02").val());
	var ab_06_d_all = parseFloat(ab_06_d_01) + parseFloat(ab_06_d_02);
	
	var menu_4 = 0;
	if(
		(
			(ab_06_a_all > ab_06_b_all && ab_06_a_all > ab_06_c_all && ab_06_a_all > ab_06_d_all) || 
			((ab_06_a_all == ab_06_b_all) || (ab_06_a_all == ab_06_c_all)  || (ab_06_a_all == ab_06_d_all))
		) && ab_06_a_all != 0
	)
	{
		// 
		if (get_zero("ab_07") != "") {
			menu_4 += 1.5;
			ab_06_a_all += 1.5;
		}
		
		menu_4 = (ab_06_a_all > 5) ? 5 : ab_06_a_all;
		result_to_show +=menu_4;
	}
	else if( 
		(
			(ab_06_b_all > ab_06_a_all && ab_06_b_all > ab_06_c_all && ab_06_b_all > ab_06_d_all) || 
			((ab_06_b_all == ab_06_a_all) || (ab_06_b_all == ab_06_c_all)  || (ab_06_b_all == ab_06_d_all))
		) && ab_06_b_all != 0
	)
	{
		// 
		if (get_zero("ab_07") != "") {
			menu_4 += 1.5;
			ab_06_b_all += 1.5;
		}
		
		menu_4 = (ab_06_b_all > 5) ? 5 : ab_06_b_all;
		result_to_show += menu_4;
	}
	else if( 
		(
			(ab_06_c_all > ab_06_a_all && ab_06_c_all > ab_06_b_all && ab_06_c_all > ab_06_d_all) || 
			((ab_06_c_all == ab_06_a_all) || (ab_06_c_all == ab_06_b_all)  || (ab_06_c_all == ab_06_d_all))
		) && ab_06_c_all != 0
	)
	{
		// 
		if (get_zero("ab_07") != "") {
			ab_06_c_all += 1.5;
			menu_4 += 1.5;
		}
		
		menu_4 = (ab_06_c_all > 5) ? 5 : ab_06_c_all;
		result_to_show += menu_4;
	}
	else if( 
		(
			(ab_06_d_all > ab_06_a_all && ab_06_d_all > ab_06_b_all && ab_06_d_all > ab_06_c_all) || 
			((ab_06_d_all == ab_06_a_all) || (ab_06_d_all == ab_06_b_all)  || (ab_06_d_all == ab_06_c_all))
		) && ab_06_d_all != 0
	)
	{
		// 
		if (get_zero("ab_07") != "") {
			ab_06_d_all += 1.5;
			menu_4 += 1.5;
		}
		
		menu_4 = (ab_06_d_all > 4.5) ? 4.5 : ab_06_d_all;
		result_to_show += menu_4;
	} else if ( 
		ab_06_a_all == 0 && ab_06_b_all == 0 && ab_06_c_all == 0 && ab_06_d_all == 0
	)
	{
		// 
		if (get_zero("ab_07") != "") {
			menu_4 += 1.5;
			result_to_show += menu_4;
		}
	}
	else
	{
		// 
		if (get_zero("ab_07") != "") {
			menu_4 += 1.5;
			result_to_show += menu_4;
		}

		//alert(ab_06_a_all + " : " + ab_06_b_all + " : " + ab_06_c_all + " : " + ab_06_d_all);
	}
	
	// 
	if (get_zero("ab_10") != "") {
		result_to_show += ((parseInt(get_zero("ab_10")) * 0.5) <= 2) ? (parseInt(get_zero("ab_10")) * 0.5):  2;
		menu_4 += ((parseInt(get_zero("ab_10")) * 0.5) <= 2) ? (parseInt(get_zero("ab_10")) * 0.5):  2;
	}

	// 
	if (get_zero("ab_11") != "") {
		result_to_show += ((parseInt(get_zero("ab_11")) * 0.25) <= 1) ? (parseInt(get_zero("ab_11")) * 0.25):  1;
		menu_4 += ((parseInt(get_zero("ab_11")) * 0.25) <= 1) ? (parseInt(get_zero("ab_11")) * 0.25):  1;
	}

	var menu_5 = 0;
	var exprience = 0;
	// تدريس سداسي دروس ( في حدود 3 نقاط)
	if (get_zero("ab_12") != "") {
		exprience += ((parseInt(get_zero("ab_12")) * 0.5) <= 3) ? (parseInt(get_zero("ab_12")) * 0.5):  3;
	}

	// تدريس سداسي أعمال موجهة ( في حدود 1,5 نقاط)
	if (get_zero("ab_13") != "") {
		exprience += ((parseInt(get_zero("ab_13")) * 0.25) <= 1.5) ? (parseInt(get_zero("ab_13")) * 0.25) : 1.5;
	}

	// تدريس  أعمال تطبيقية ( في حدود 1,5 نقاط)
	if (get_zero("ab_14") != "") {
		exprience += ((parseInt(get_zero("ab_14")) * 0.25) <= 1.5) ? (parseInt(get_zero("ab_14")) * 0.25) : 1.5;
	}

	if (get_zero("ab_15") != "") {
		exprience += ((parseInt(get_zero("ab_15")) * 0.5) <= 1.5) ? (parseInt(get_zero("ab_15")) * 0.5) : 1.5;
	}

	if (get_zero("ab_16") != "") {
		exprience += ((parseInt(get_zero("ab_16")) * 0.25) <= 1.5) ? (parseInt(get_zero("ab_16")) * 0.25) : 1.5;
	}
	
	menu_5 = (exprience > 3) ? 3 : exprience;
	result_to_show += menu_5;
	
	// المقابلة مع لجنة الانتقاء : 
	var menu_6 = (parseFloat(get_zero("ab_17")) <= 4) ? parseFloat(get_zero("ab_17")) : 4;
	result_to_show += menu_6;

	if(isNaN(result_to_show))
		result_to_show = "0";

	$("#result_to_show").html(`
		<span style="text-align: right;"><b>${result_to_show} نقطة</b></span>
	`);
	
	abgrcs_config.save_static("2");

	Update_Sub_Total(menu_1, menu_2, menu_3, menu_4, menu_5, menu_6);
}

export default Home;
